import React from "react";
import SharedExerciseReviewContent from "../../../components/exercise-review-content/ExerciseReviewContent";
import { TeacherNotificationItem } from "../../../services/notifications/notification.service";

export interface ExerciseReviewContentProps {
  notification: TeacherNotificationItem;
  onOpenExercise?: (exerciseId: number) => void;
}

export const ExerciseReviewContent: React.FC<ExerciseReviewContentProps> = ({
  notification,
  onOpenExercise,
}) => {
  return (
    <SharedExerciseReviewContent
      notification={notification}
      showTeacherComment={true}
      onOpenExercise={onOpenExercise}
    />
  );
};

export default ExerciseReviewContent;
